import { AMBYSS } from './full/ambyss';
import { AVATAR, AVATAR_UPGRADES, type CycleAttack, type DechaineEffect } from './full/avatar';
import type { ChargedAttack } from './full/attacks';
import { AMBYSS_TRACKS } from './full/ambyss-tracks';
import { DOME } from './full/dome';
import { DOME_TRACKS } from './full/dome-tracks';
import { CANICULE, type HeatEffect } from './full/canicule';
import { type BlackoutEffect, FAUX_CONTACT } from './full/faux-contact';
import { type BeatArmorEffect, LARSEN } from './full/larsen';
import { MOUSTIQUES, type StingEffect } from './full/moustiques';
import { ORAGE, type PuddleEffect } from './full/orage';
import { FESTIVAL_PATHS } from './full/festival';
import { PUMPUI } from './full/pumpui';
import { PUMPUI_TRACKS } from './full/pumpui-tracks';
import { FULL_SUMMONS } from './full/summons';
import { type CascadeEffect, type ClubsAttack, JONGLEUR, JONGLEUR_UPGRADES } from './full/jongleur';
import { type BallAttack, SPORTIF, SPORTIF_UPGRADES, type SprintEffect } from './full/sportif';
import { type InkAttack, type MotifEffect, TATOUE, TATOUE_UPGRADES } from './full/tatoue';
import { ENRACINE, ENRACINE_UPGRADES, type FoxAttack, type HibouEffect } from './full/enracine';
import {
  type LanterneEffect,
  type SwarmAttack,
  VEILLEUR,
  VEILLEUR_UPGRADES,
} from './full/veilleur';
import { type BroodAttack, type DebandadeEffect, POUSSIN, POUSSIN_UPGRADES } from './full/poussin';
import {
  CELESTE,
  CELESTE_UPGRADES,
  type MeteorsEffect,
  type ShootingStarAttack,
} from './full/celeste';
import { BABACOOL, BABACOOL_UPGRADES, type EchoAttack, type HalfTimeEffect } from './full/babacool';
import {
  CIRCADIEN,
  CIRCADIEN_UPGRADES,
  type CircadianAttack,
  type EclipseEffect,
} from './full/circadien';
import {
  type GlowstickAttack,
  type RappelEffect,
  SUPERFAN,
  SUPERFAN_UPGRADES,
} from './full/superfan';
import type {
  ClassDefinition,
  EnemyDefinition,
  MusicTrack,
  SetDefinition,
  TeaserDefinition,
  UpgradeDefinition,
} from './types';

// The demo swaps in `full.demo.ts` (ADR 0015).
export const FULL_CLASSES: readonly ClassDefinition[] = [
  SPORTIF,
  TATOUE,
  SUPERFAN,
  ENRACINE,
  VEILLEUR,
  CELESTE,
  BABACOOL,
  POUSSIN,
  AVATAR,
  JONGLEUR,
  CIRCADIEN,
];
export const FULL_UPGRADES: readonly UpgradeDefinition[] = [
  ...SPORTIF_UPGRADES,
  ...TATOUE_UPGRADES,
  ...SUPERFAN_UPGRADES,
  ...ENRACINE_UPGRADES,
  ...VEILLEUR_UPGRADES,
  ...CELESTE_UPGRADES,
  ...BABACOOL_UPGRADES,
  ...POUSSIN_UPGRADES,
  ...AVATAR_UPGRADES,
  ...JONGLEUR_UPGRADES,
  ...CIRCADIEN_UPGRADES,
];
export const FULL_SETS: readonly SetDefinition[] = [DOME, AMBYSS, PUMPUI];
export const FULL_PATHS: readonly SetDefinition[] = FESTIVAL_PATHS;
export const FULL_TRACKS: readonly MusicTrack[] = [
  ...DOME_TRACKS,
  ...AMBYSS_TRACKS,
  ...PUMPUI_TRACKS,
];
export const FULL_ENEMIES: readonly EnemyDefinition[] = [
  ORAGE,
  CANICULE,
  LARSEN,
  MOUSTIQUES,
  FAUX_CONTACT,
];
export { FULL_SUMMONS };
// Only the demo shows characters and stages locked.
export const FULL_TEASERS: readonly TeaserDefinition[] = [];

export type FullSpecialEffect =
  PuddleEffect | HeatEffect | BeatArmorEffect | StingEffect | BlackoutEffect;

export type FullAttack =
  | ChargedAttack
  | ClubsAttack
  | BallAttack
  | InkAttack
  | GlowstickAttack
  | FoxAttack
  | SwarmAttack
  | ShootingStarAttack
  | EchoAttack
  | CircadianAttack
  | BroodAttack
  | CycleAttack;

export type FullSkillEffect =
  | CascadeEffect
  | SprintEffect
  | MotifEffect
  | RappelEffect
  | HibouEffect
  | LanterneEffect
  | MeteorsEffect
  | HalfTimeEffect
  | EclipseEffect
  | DebandadeEffect
  | DechaineEffect;
